

  <nav class="navbar sub-navigation with-overflow" id="top">
    <ul class="navbar-secondary">
      <li *ngFor="let item of filteredCategories">
        <a id="aTag" (click)="gototab(item.num,$event,item)" class="sport-link-racing " [ngClass]="{'active':item.active}" >
          <img src="{{item.image}}" class="icon" alt="category" style="margin-bottom: 0.2rem;" id="imgTag" />
          {{item.name}}
        </a>
      </li>
    </ul>
  </nav>


  <app-kiron *ngIf="kiron"></app-kiron>
  <app-next-ten-odds [selectedBetCategory]="selectedBetCategory" *ngIf="next10"></app-next-ten-odds>
  <app-track-side *ngIf="trackside"></app-track-side>
  <app-all-racing-odds [selectedBetCategory]="selectedBetCategory" *ngIf="allrace"></app-all-racing-odds>
  <app-nova *ngIf="nova"></app-nova>
  <app-lucky-horse *ngIf="luckyHorse"></app-lucky-horse>
  <app-cricket-super-over *ngIf="cricketSuperOver"></app-cricket-super-over>
  <app-racing-roulette *ngIf="racingRoulette"></app-racing-roulette>
  <app-keno *ngIf="keno"></app-keno> 
  <app-lucky-loot *ngIf="luckyloot"></app-lucky-loot>
  
  
  
 





